import { z } from "zod";

import { OfferProductDtoSchema } from "../../../dtos/offer-products";
import { OfferDtoSchema } from "../../../dtos/offers";

export const PutOfferRequestPathParamSchema = z.object({
  offerId: z.string().uuid(),
  variationId: z.string().uuid(),
});

export type PutOfferRequestPathParamType = z.infer<
  typeof PutOfferRequestPathParamSchema
>;

export const PutOfferRequestBodySchema = z.object({
  offer: OfferDtoSchema,
  offerProducts: OfferProductDtoSchema.array(),
});

export type PutOfferRequestBodyType = z.infer<typeof PutOfferRequestBodySchema>;

export const PutOfferResponseBodySchema = z.object({
  offer: OfferDtoSchema,
});

export type PutOfferResponseBodyType = z.infer<
  typeof PutOfferResponseBodySchema
>;
